export const imageUrl = path => "https://strapi.nocturnal-unrest.de" + path

export const fileUrl = path => "https://strapi.nocturnal-unrest.de" + path